import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import BaseOverLay from './UI/BaseOverlay.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('base-overlay', BaseOverLay)
